<template>
    <section class="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto">
            <div class="px-4 sm:px-8 flex flex-row flex-wrap w-full pb-4 sm:pb-8">
                <div
                    class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-8 mt-4 sm:mt-8">
                    <tile v-for="(item, index) in filteredMenu" :key="index" :item="item"></tile>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Tile from "../../components/shared/Tile.vue";
export default {
    name: "survey-and-feedback-center-index",
    components: {
        Tile,
    },
    data() {
        return {
            menu: [
                {
                    id: 0,
                    isActive: true,
                    isImage: true,
                    path: "/my-surveys",
                    title: "My Surveys",
                    icon: ``,
                    image: require('../../assets/images/icons/img1.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                },
                {
                    id: 1,
                    isActive: true,
                    isImage: true,
                    path: "/survey",
                    title: "Survey",
                    icon: ``,
                    image: require('../../assets/images/icons/img1.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                    role: ['superadmin', 'admin', 'Viewer', 'faculty'],
                    permission: "survey-management",
                },
                {
                    id: 2,
                    isActive: true,
                    isImage: true,
                    path: "/course-evaluation-survey",
                    title: "Course Evaluation Survey",
                    icon: ``,
                    image: require('../../assets/images/icons/img3.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                    role: ['superadmin', 'admin', 'Viewer'],
                    permission: "course-evaluation-survey",
                },
                {
                    id: 3,
                    isActive: true,
                    isImage: true,
                    path: "/smart-feedback-dashboard",
                    title: "Feedback",
                    icon: ``,
                    image: require('../../assets/images/icons/img2.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                    role: ['superadmin', 'admin', 'Viewer'],
                    permission: "feedback-dashboard",
                },
            ],
        };
    },
    computed: {
        role() {
            return this.$store.getters.role;
        },
        permissions() {
            return this.$store.getters.permissions;
        },
        filteredMenu() {
            return this.menu.filter(item => {
                // Superadmin always has access
                if (this.role === 'superadmin') {
                    return true;
                }

                // Check if user has the required role (if roles are specified)
                const hasRole = !item.role || item.role.length === 0 || item.role.includes(this.role);

                // Check if user has the required permission (if permission is specified)
                const hasPermission = !item.permission || this.permissions.includes(item.permission);

                // Show menu if user has either the role OR the permission
                return hasRole || hasPermission;
            });
        },
    },
}
</script>